import {
  defaultCellRenderer,
  defaultGroupRenderer as groupRenderer,
  linkifyText
} from "../../utils/utils.jsx";
import { WIDGET_KEYS } from "../WidgetKeys.jsx";
import { customGroupByOrder } from "../../utils/otherUtils.jsx";
import { TASK_BUDGET_FIELDS } from "../OtherKeys.jsx";

export const PLAN_VIEW_COLUMNS = [
  {
    id: "plan-task-name",
    type: "unplannedTask",
    text: "Task",
    field: "name",
    editor: false,
    region: "left",
    cellCls: "b-sch-horizontal",
    regionsToIgnore: ["left"],
    headerMenuItems: {
      addNewEntity: {
        _menuId: "task",
        icon: "b-fa-plus",
        text: "New Task",
        weight: 10,
      },
      taskFinder: {
        _menuId: "taskFinder",
        icon: "b-fa b-fa-search",
        weight: 430,
        text: "Find",
      },
      textWrapping: {
        text: "Enable Text Wrapping",
        checked: false,
        weight: 440,
        regionsToIgnore: ["left"]
      }
    }
  },
  { id: "plan-task-alert-checklist", type: WIDGET_KEYS.checklistColumn },
  {
    id: "plan-task-istaskscheduled",
    type: WIDGET_KEYS.scheduledColumn
  },
  { id: "plan-task-notes", type: WIDGET_KEYS.notesColumn },
  { id: "plan-task-files", type: WIDGET_KEYS.filesColumn },
  {
    id: "plan-budget-column",
    type: WIDGET_KEYS.budgetAccountColumn,
  },
  { id: "plan-task-budget-id", type: WIDGET_KEYS.columnTaskBudgetTitle, text: "Budget ID", editor: false, field: TASK_BUDGET_FIELDS.title},
  {
    id: "plan-task-team",
    text: "Team",
    field: "teamValue",
    type: WIDGET_KEYS.teamField,
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    },
    editor: false,
  },
  {
    id: "plan-task-address",
    text: "Address",
    field: "formattedAddress",
    swivuPickerDisplayField: "formattedAddress",
    swivuRecordField: "address",
    type: WIDGET_KEYS.swivuAddressColumn,
    editor: false,
  },
  {
    id: "plan-task-aging",
    text: "Age",
    field: "aging",
    flex: 1,
    type: "agingColumn",
    editor: false
  },
  {
    id: "plan-task-status",
    text: "Status",
    type: WIDGET_KEYS.columnTaskStatus,
    field: "statusValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    },
    editor: false,
  },
  {
    id: "plan-task-description",
    text: "Description",
    field: "description",
    type: WIDGET_KEYS.swivuStateColumn,
    flex: 1,
    cellCls: "!overflow-hidden",
    renderer: ({ record }) => linkifyText(defaultCellRenderer({ value: record.description })),
    regionsToIgnore: ["left"],
    groupRenderer,
    headerMenuItems: {
      textWrapping: {
        text: "Enable Text Wrapping",
        checked: false,
        regionsToIgnore: ["left"]
      }
    },
    editor: false,
  },
  {
    id: "plan-task-category",
    text: "Category",
    type: WIDGET_KEYS.columnTaskCategory,
    field: "categoryValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    },
    editor: false,
  },
  {
    id: "plan-task-tag",
    text: "Tags",
    type: WIDGET_KEYS.columnTaskTag,
    flex: 1,
    field: "tagsValue",
    editor: false,
  },
  {
    id: "plan-time-axis-column",
    type: 'timeAxis',
  }
]
